import { useMsal } from "@azure/msal-react";
import "./index.css";
import MaintenanceImg from "/src/assets/images/camion_salmones_500.jpg";
import { Button } from "primereact/button";
import { useState } from "react";

export default function ErrorUsuAdNoBd() {
  const { instance } = useMsal();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  };
  return (
    <div style={{ margin: "50px" }}>
      <h1 style={{ textAlign: "center", fontSize: "36px" }}>
        ¡NO TIENES ACCESO A ESTE SISTEMA!
      </h1>
      <div className="wrap">
        <img alt="" width="800px" height="500px" src={MaintenanceImg} />

        <p style={{ fontSize: "16px" }}>
          ¡Oopps! Lo sentimos, tu usuario pertenece ha un dominio válido; sin
          embargo, no está habilitado para este sistema.
        </p>

        <Button
          style={{
            ...styles.enabledAdLoginButton,
            backgroundColor: isHovered ? "white" : "red",
            color: isHovered ? "black" : "white",
          }}
          icon="pi pi-microsoft"
          label="REGRESAR Y CERRAR"
          onClick={logout}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          text
        ></Button>

        <p style={{ fontSize: "12px" }}>
          Comunícate con tu jefatura directa, para solicitar el acceso al
          departamento TI.
        </p>
      </div>
    </div>
  );
}

const styles = {
  enabledLoginButton: {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    margin: 10,
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },

  enabledLoginButtonHover: {
    backgroundColor: "white",
    color: "black",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },
  enabledAdLoginButton: {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
    margin: "20px",
    height: "7%",
    padding: "10px",
    fontFamily: "math",
    fontSize: "12px",
  },
  errorMessage: {
    display: "inherit",
    fontSize: "10px",
    color: "#ff3d3d",
  },
};
